<template>
    <div>
        <a
            href="https://wa.me/573188274142?text=Hola%2C%20te%20escribo%20a%20trav%C3%A9s%20de%20la%20p%C3%A1gina%20web%2C%20estoy%20interesado%20en%3A"
            class="float"
            target="_blank"
            aria-label="Contactar por Whatsapp"
        >
            <i class="fa fa-whatsapp my-float"></i>
        </a>
        <!-- <div class="">
            <a v-b-toggle.sidebar-right class="float" aria-label="Contactar por Whatsapp">
                <i class="fa fa-whatsapp my-float"></i>
            </a>
            <b-sidebar id="sidebar-right" right shadow>
                <div class="p-3">
                    <h5 class="text-center text-muted mb-0">
                        ¡Bienvenid@!
                    </h5>
                    <p class="text-center">
                        <b> ¿Necesitas ayuda? </b> <br />
                        Contacta con nuestro equipo
                    </p>
                    <div class="recent_addedcars mt-5">
                        <ul>
                            <li class="gray-bg">
                                <div class="recent_post_img">
                                    <a href=""
                                        ><img
                                            src="/assets/images/Logo-perfilwp.png"
                                    /></a>
                                </div>
                                <div class="recent_post_title">
                                    <div class="title-li">
                                        <b>Sede Calle 5 </b> <br />
                                        <small>Depto. Ventas</small>
                                    </div>
                                    <b-row class="text-center mt-4">
                                        <b-col>
                                            <a
                                                href="https://wa.link/axe8kp"
                                                target="_blank"
                                                class="icon-whatsapp"
                                            >
                                                <i
                                                    class="fa fa-whatsapp"
                                                    aria-hidden="true"
                                                ></i
                                            ></a>
                                        </b-col>
                                        <b-col>
                                            <a
                                                href="tel:+573188274142"
                                                target="_blank"
                                                class="icon-phone"
                                            >
                                                <i
                                                    class="fa fa-mobile"
                                                    aria-hidden="true"
                                                ></i
                                            ></a>
                                        </b-col>
                                        <b-col>
                                            <a
                                                href="mailto:servicioalcliente@redautos.com"
                                                target="_blank"
                                                class="icon-envelope"
                                            >
                                                <i
                                                    class="fa fa-envelope"
                                                    aria-hidden="true"
                                                ></i
                                            ></a>
                                        </b-col>
                                    </b-row>
                                </div>
                            </li>
                            <li class="gray-bg">
                                <div class="recent_post_img">
                                    <a href=""
                                        ><img
                                            src="/assets/images/Logo-perfilwp.png"
                                    /></a>
                                </div>
                                <div class="recent_post_title">
                                    <div class="title-li">
                                        <b>Sede Calle 8</b> <br />
                                        <small>Depto. Ventas</small>
                                    </div>
                                    <b-row class="text-center mt-4">
                                        <b-col>
                                            <a
                                                href="https://wa.link/76qvav"
                                                target="_blank"
                                                class="icon-whatsapp"
                                            >
                                                <i
                                                    class="fa fa-whatsapp"
                                                    aria-hidden="true"
                                                ></i
                                            ></a>
                                        </b-col>
                                        <b-col>
                                            <a
                                                href="tel:+573206660716"
                                                target="_blank"
                                                class="icon-phone"
                                            >
                                                <i
                                                    class="fa fa-mobile"
                                                    aria-hidden="true"
                                                ></i
                                            ></a>
                                        </b-col>
                                        <b-col>
                                            <a
                                                href="mailto:servicioalcliente@redautos.com"
                                                target="_blank"
                                                class="icon-envelope"
                                            >
                                                <i
                                                    class="fa fa-envelope"
                                                    aria-hidden="true"
                                                ></i
                                            ></a>
                                        </b-col>
                                    </b-row>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </b-sidebar>
        </div> -->
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.float {
    position: fixed;
    width: 60px;
    height: 60px;
    bottom: 40px;
    right: 40px;
    background-color: #000000;
    color: #fff;
    border-radius: 50px;
    text-align: center;
    font-size: 30px;
    box-shadow: 2px 2px 3px #999;
    z-index: 100;
}

.my-float {
    margin-top: 16px;
    color: #fff;
}
a.icon-whatsapp {
    color: #1a1a1a;
    font-size: 25px;
}
a.icon-phone {
    color: #1a1a1a;
    font-size: 25px;
}
a.icon-envelope {
    color: #1a1a1a;
    font-size: 25px;
}
.title-li {
    line-height: 16px;
}
</style>
